import type { BaDevice } from '@/types/database/baDevice';
import client from '@/lib/feathers';

export default async function getBADevice(baId: string) {
  const deviceTextType = ['電表關', '電表開', '電表通電'];
  const baDeviceService = client.service('baDevice');
  const res = await baDeviceService.find({
    query: {
      text: { $in: deviceTextType.map((text) => `${text}${baId}`) },
    },
  });
  const resultBADevice: BaDevice[] = [...res.data];
  return resultBADevice;
}
